import * as React from 'react'
import Divider from '@mui/material/Divider'
import { Link } from 'react-router-dom'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

type VendorManageNavigationItemProps = {
  isSelected: boolean
  to: string
  primaryText: string
  secondaryText: string
  icon: React.ReactElement
}

const VendorManageNavigationItem: React.FC<VendorManageNavigationItemProps> = ({
  isSelected,
  to,
  primaryText,
  secondaryText,
  icon
}) => {
  return (
    <>
      <ListItemButton sx={{ pt: 2, pb: 2 }} selected={isSelected} component={Link} to={to} disableRipple>
        <ListItemIcon sx={{ alignSelf: 'flex-start', mt: 1 }}>
          {React.cloneElement(icon, { color: isSelected ? 'primary' : 'inherit' })}
        </ListItemIcon>
        <ListItemText primary={primaryText} secondary={secondaryText} />
      </ListItemButton>
      <Divider />
    </>
  )
}

export default VendorManageNavigationItem
